/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import moment from"moment";

const AUTH_TOKEN_KEY = 'authToken';
export interface AuthToken {
  access_token: string;
  expires: string;
  token_type: string;
}

export function loadToken(): AuthToken | null {
  const strToken = window.localStorage.getItem(AUTH_TOKEN_KEY);
  if (strToken === null) return null;

  const token = JSON.parse(strToken);

  if (moment(new Date(token.expires)).isBefore(moment.now())) { // Perform expiry check
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
    return null;
  }

  return token;
}

export interface ServerAuthToken {
  access_token: string,
  expires_in: number,
  token_type: string,
  scope: string,
}

export function saveToken(token: ServerAuthToken) {
  const appToken = JSON.stringify({
    access_token: token.access_token,
    expires: moment().add(token.expires_in, 's').toString(),
    token_type: token.token_type
  });
  window.localStorage.setItem(AUTH_TOKEN_KEY, appToken);
}

export function saveTokenString(access_token: string, scope: string[]) {
  const appToken = JSON.stringify({
    access_token: access_token,
    expires: moment().add(86400, 's').toString(),
    token_type: 'Bearer'
  });
  window.localStorage.setItem(AUTH_TOKEN_KEY, appToken);
}

export function clearToken() {
  window.localStorage.removeItem(AUTH_TOKEN_KEY);
}
